import { render, staticRenderFns } from "./ReporteCobradoXFechaI.vue?vue&type=template&id=14438a26&scoped=true"
import script from "./ReporteCobradoXFechaI.vue?vue&type=script&lang=js"
export * from "./ReporteCobradoXFechaI.vue?vue&type=script&lang=js"
import style0 from "./ReporteCobradoXFechaI.vue?vue&type=style&index=0&id=14438a26&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14438a26",
  null
  
)

export default component.exports